import { Component, ElementRef, HostListener, Input, OnInit, Output } from '@angular/core';
import { COLORS_DATA } from '@app/core/components/color-picker/constants/color-picker-data-colors.constant';
import { AppearanceService } from '@app/core/dialogs/appearance/appearance.service';

@Component({
  selector: 'app-color-picker',
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.scss'],
})
export class ColorPickerComponent implements OnInit {
  public colors: string[] = COLORS_DATA;
  public showPicker: boolean = false;

  public onClickout: boolean = true;
  public selectedColor: string = '';

  @HostListener('document:click', ['$event'])
  clickout(event: MouseEvent) {
    if (!this.elRef.nativeElement.contains(event.target) && this.onClickout) {
      this.showPicker = false;
    }
  }

  @Input() public isDefault;
  @Input() public isSimple;
  @Input() public isPopup;
  @Input() public currentColor;
  @Input() public isDisabled;
  @Input() public type: string;

  constructor(
    private elRef: ElementRef,
    private appearanceService: AppearanceService,
  ) {}

  public ngOnInit(): void {}

  public pickColor(): void {
    this.showPicker = !this.showPicker;
  }

  public onBasicColorClick(color: string) {
    this.type === 'type' ? this.appearanceService.setNewTypeColor(color) : this.appearanceService.setNewDrawColor(color);
    this.currentColor = color;
    this.selectedColor = color;
    this.showPicker = false;
  }
}
